import { useTranslation } from 'react-i18next';

import { AdditionalCapacity } from 'components/types';

import { formatISOString } from 'utils/date';

import { Box } from '@mui/material';

import { Tooltip } from 'components/shared';

type Props = {
  row: AdditionalCapacity;
};

const AdditionalCapacityStatusInformation = ({ row }: Props) => {
  const { t } = useTranslation();

  let dateInfo;

  switch (row.status.toLowerCase()) {
    case t('rejected').toLowerCase():
      dateInfo = row.rejectedOn
        ? `${t('on')} ${formatISOString(row.rejectedOn)}`
        : '';
      break;
    case t('approved').toLowerCase():
      dateInfo = row.approvedOn
        ? `${t('on')} ${formatISOString(row.approvedOn)}`
        : '';
      break;
    default:
      dateInfo = row.createdOn
        ? `${t('on')} ${formatISOString(row.createdOn)}`
        : '';
      break;
  }

  return (
    <Box display="flex" flexDirection="column">
      {row.status.toLowerCase() === t('rejected').toLowerCase() ? (
        <Tooltip title={`${row.reason}` ?? ''} arrow>
          <span>{row.status}</span>
        </Tooltip>
      ) : (
        <span>{row.status}</span>
      )}
      <span style={{ fontSize: '80%', fontFamily: 'signikalight' }}>
        {dateInfo}
      </span>
    </Box>
  );
};

export default AdditionalCapacityStatusInformation;
